import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';

export type TooltipProps = TooltipPrimitive.Root.Props;
export type LegacyTooltipCompatProps = Record<string, unknown>;

const Tooltip = ({ ...props }: TooltipProps & LegacyTooltipCompatProps) => {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
};

export default Tooltip;
